import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type Asset } from '../../services/assetByIdService'

export interface AssetByIdState {
  isLoading: boolean
  assetData: Asset | null
  errorMessage: string | null
  httpStatus: number | null
}

const initialState: AssetByIdState = {
  isLoading: false,
  assetData: null,
  errorMessage: null,
  httpStatus: null
}

export const assetByIdSlice = createSlice({
  name: 'assetById',
  initialState,
  reducers: {
    assetByIdDataLoading: (state): AssetByIdState => {
      return {
        isLoading: true,
        assetData: null,
        errorMessage: null,
        httpStatus: 0
      }
    },
    assetByIdDataError: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>): AssetByIdState => {
      return {
        isLoading: false,
        assetData: null,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    },
    addAssetByIdData: (state, action: PayloadAction<{ data: Asset, httpStatus: number }>): AssetByIdState => {
      return {
        isLoading: false,
        assetData: action.payload.data,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const { assetByIdDataLoading, assetByIdDataError, addAssetByIdData } = assetByIdSlice.actions
export default assetByIdSlice.reducer
